class WishLists extends HTMLElement {
  static get observedAttributes() {
    return ['data-customer-id', 'data-type', 'data-merchant-id'];
  }

  constructor() {
    super();
    
    this.wrapper = this.querySelector('.wishlists__wrapper');
    this.listToggle = this.querySelector('.wishlists__list-toggle');
    this.itemToggles = this.querySelectorAll('.wishlists__item-toggle');
    this.itemAdd = this.querySelector('.wishlists__item-add');
    this.messageBox = this.querySelector('.wishlists__message');
    this.wishlistDataElement = document.getElementById('customerWishlistData');
    this.wishlistData = JSON.parse(this.wishlistDataElement.textContent);

    this.customerId = this.wishlistData?.customerId ?? null;
    this.type = this.wishlistData?.type ?? 'company';
    this.company = this.wishlistData?.company ?? '';
    this.merchantId = this.wishlistData?.merchantId ?? null;
    this.isFavorite = this.wishlistData?.isFavorite ?? false;
    this.wishlists =
      this.wishlistData?.wishlists && this.wishlistData?.wishlists?.length > 0
        ? this.wishlistData?.wishlists
        : [];

    this.listToggle.addEventListener('click', () => {
      this.toggleDropdown();
    });

    this.itemToggles.forEach((itemToggle) => {
      itemToggle.addEventListener('click', () => {
        this.saveProductToList(itemToggle);
      });
    });

    this.itemAdd.addEventListener('click', () => {
      this.addNewList();
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'data-customer-id':
        this.customerId = newValue ? Number(newValue) : null;
        break;
      case 'data-type':
        this.type = newValue ? newValue : 'company';
        break;
      case 'data-merchant-id':
        this.merchantId = newValue ? newValue : null;
        break;
    }
  }

  toggleDropdown() {
    this.wrapper.classList.toggle('wishlists__wrapper--open');
  }

  async saveProductToList(itemToggle) {
    const wishlistProducts = document.querySelectorAll('.wishlist_item');
    let customerWishlists = {};
    let updateWishlist = {};
    let itemAdded = false;

    if (!itemToggle.dataset.id && this.wishlists.length === 0) {
      customerWishlists = {
        customerId: this.customerId,
        merchantId: this.merchantId,
        company: '',
        type: this.type,
        wishlists: this.wishlists,
      };
      const newWishlist = {
        customerId: customerWishlists.customerId,
        name: String(itemToggle.innerText),
        list: [],
        isFavorite: false,
      };

      wishlistProducts.forEach((item) => {
        const newProduct = {
          productId: item.dataset.variantId,
          productHandle: item.dataset.productHandle,
          quantity:
            Number(item.dataset.quantity) === 0
              ? 1
              : Number(item.dataset.quantity),
        };
        newWishlist.list.push(newProduct);
      });

      customerWishlists.wishlists.push(newWishlist);
    }

    if (this.wishlists.length > 0) {
      customerWishlists = {
        customerId: this.customerId,
        merchantId: this.merchantId,
        company: '',
        type: this.type,
        wishlists: this.wishlists,
      };

      updateWishlist = {
        customerId: Number(customerWishlists.customerId),
        name: String(itemToggle.innerText),
        list: [],
        isFavorite: this.isFavorite,
      };

      if (itemToggle.dataset.id) {
        updateWishlist = {
          ...updateWishlist,
          list: this.wishlists.find(
            (wishlist) => wishlist.id === itemToggle.dataset.id
          ).list,
          id: itemToggle.dataset.id,
        };
      }

      wishlistProducts.forEach((item) => {
        const checkVariant = document.querySelector(
          'input[name="id"].product-variant-id'
        );

        const newProduct = {
          productId: checkVariant?.value ?? item.dataset.variantId,
          productHandle: item.dataset.productHandle,
          quantity:
            Number(item.dataset.quantity) === 0
              ? 1
              : Number(item.dataset.quantity),
        };

        if (
          !updateWishlist.list.find(
            (product) => product.productId === newProduct.productId
          )
        ) {
          updateWishlist.list.push(newProduct);
          itemAdded = true;
          if (!itemToggle.dataset.id) {
            customerWishlists.wishlists.push(updateWishlist);
          }
        }
      });
    }

    this.toggleDropdown();

    if (!itemAdded) {
      const messageLink = `<a href="/pages/wishlist#${itemToggle.dataset.id}">${itemToggle.textContent}</a>`;
      this.messageBox.innerHTML = `Item variant is already in ${messageLink}`;
      this.messageBox.classList.add(`wishlists__message--visible`);
      
      return;
    }


    this.messageBox.innerHTML = `Adding Item...`;
    this.messageBox.classList.add(`wishlists__message--visible`);

    try {
      if (!itemToggle.dataset.id && this.wishlists.length === 0) {
        const response = await this.createWishlists(customerWishlists);

        return console.log(await response.json());
      } else {
        const response = await this.updateWishlist(
          customerWishlists.wishlists.find(
            (wishlist) => wishlist.id === itemToggle.dataset.id
          )
        );

        const wishlistObj = response.customer.metafields.edges.find((mf) => mf.node.key == "wishishlist");
        this.wishlistData = JSON.parse(wishlistObj.node.value);
        if (!itemToggle.dataset.id) {
          const newWishlist = this.wishlistData.wishlists.find((wl) => wl.name == itemToggle.textContent.trim());

          if (newWishlist) {
            itemToggle.dataset.id = newWishlist.id;
          }
        }

        const messageLink = `<a href="/pages/wishlist#${itemToggle.dataset.id}">${itemToggle.textContent.trim()}</a>`;
        this.messageBox.innerHTML = `Item Added to ${messageLink}`;
        this.messageBox.classList.add(`wishlists__message--visible`);
      }
    } catch (error) {
      return console.error(error);
    }
  }

  addNewList() {
    const lastItem = this.itemAdd.closest('.wishlists__item');
    const item = document.createElement('li');
    const button = document.createElement('button');
    const input = document.createElement('input');
    const name = document.createElement('span');
    const icon = [...this.itemAdd.children].find((el) => el.tagName === 'svg');

    item.classList.add('wishlists__item');
    button.classList.add('wishlists__item-toggle');
    name.classList.add('wishlists__item-name');
    input.classList.add('wishlists__item-input');

    input.setAttribute('type', 'text');
    input.setAttribute('aria-label', 'New list name');

    lastItem.insertAdjacentElement('beforebegin', item);
    item.insertAdjacentElement('beforeend', input);
    button.insertAdjacentElement('beforeend', name);
    button.insertAdjacentElement('beforeend', icon.cloneNode(true));

    input.focus();

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        if (input.value !== '') {
          name.textContent = input.value;
          item.replaceChild(button, input);
        } else {
          item.remove();
        }
      }
    });

    button.addEventListener('click', () => {
      this.saveProductToList(button);
    });
  }

  formatCustomerID(customerID) {
    return `gid://shopify/Customer/${customerID}`;
  }

  async createWishlists(newCustomerWishlist) {
    const wishlist = newCustomerWishlist;
    if (!wishlist?.customerId) {
      throw new Error('customerId cannot be null.');
    }

    if (!wishlist?.merchantId) {
      throw new Error('merchantId cannot be null.');
    }

    if (!wishlist?.wishlists || wishlist?.wishlists.length === 0) {
      throw new Error('Wishlists must have at least one wishlist item.');
    }

    for (const individualWishlist of wishlist?.wishlists) {
      if (!individualWishlist?.customerId) {
        throw new Error('Wishlist customerId cannot be empty.');
      }
      if (!individualWishlist?.name || individualWishlist?.name.trim() === '') {
        throw new Error('Wishlist name is required.');
      }
    }

    const formData = new FormData();

    formData.append('formAction', 'CREATE_WISHLIST');
    formData.append('company', wishlist?.company ?? '');
    formData.append('customerId', wishlist?.customerId ?? this.customerId);
    formData.append('type', wishlist?.type ?? 'individual');
    formData.append('merchantId', wishlist?.merchantId ?? 'merchantId2');

    if (wishlist?.wishlists && wishlist?.wishlists.length > 0) {
      for (const individualWishlist of wishlist?.wishlists) {
        individualWishlist.customerId = wishlist?.customerId ?? this.customerId;
      }
    }
    formData.append('wishlists', JSON.stringify(wishlist?.wishlists ?? []));

    const response = await fetch(`/apps/api/wishlists`, {
      method: 'POST',
      body: formData,
    });

    const data = await response;
    return data;
  }

  async updateWishlist(updateWishlist) {
    const wishlist = {
      customerId: updateWishlist?.customerId ?? this?.customerId,
      id: updateWishlist?.id ?? null,
      name: updateWishlist?.name ?? null,
      list: updateWishlist?.list ?? [],
      isFavorite: updateWishlist?.isFavorite ?? false,
    };
    if (!wishlist?.customerId) {
      throw new Error('customerId cannot be null.');
    }

    if (wishlist?.name && wishlist?.name.trim() === '') {
      throw new Error('wishlist "name" cannot be empty.');
    }

    if (!wishlist?.list) {
      throw new Error('wishlist "list" cannot be null.');
    }

    if (wishlist?.list && wishlist?.list?.length > 0) {
      for (const item of wishlist.list) {
        if (!item?.productId || item.productId.trim() === '') {
          throw new Error('Product ID is required for each item.');
        }
        if (!item?.quantity || item.quantity === null) {
          throw new Error('Quantity must be at least 1.');
        }
      }
    }

    const formData = new FormData();
    formData.append('formAction', 'UPDATE_WISHLIST');
    formData.append('customerId', wishlist.customerId);
    formData.append('id', wishlist.id ?? '');
    formData.append('name', wishlist.name);
    formData.append('list', JSON.stringify(wishlist.list));
    formData.append('isFavorite', wishlist.isFavorite);

    const response = await fetch(`/apps/api/wishlists`, {
      method: 'PUT',
      body: formData,
    });
    const data = await response.json();
    return data;
  }

  async deleteAllWishlists(customerId) {
    if (!customerId) {
      throw new Error('customerId cannot be null.');
    }
    const formData = new FormData();
    formData.append('formAction', 'DELETE_WISHLISTS');
    formData.append('customerId', customerId);
    const response = await fetch(`/apps/api/wishlists`, {
      method: 'DELETE',
      body: formData,
    });
    const data = await response.json();
    return data;
  }

  async deleteWishlists(wIds) {
    if (!wIds) {
      throw new Error('Provide at least 1 wishlist ID to delete.');
    }
    if (this.customerId === null) {
      throw new Error('customerId cannot be null.');
    }
    const wishlistIds = [...wIds];
    const formData = new FormData();
    formData.append('formAction', 'DELETE_WISHLIST');
    formData.append('customerId', this.customerId);
    formData.append('wishlistIds', JSON.stringify(wishlistIds));
    const response = await fetch(`/apps/api/wishlists`, {
      method: 'DELETE',
      body: formData,
    });
    const data = await response.json();
    return data;
  }

  async deleteWishlistItems({ wishlistId, productIds }) {
    if (!wishlistId) {
      throw new Error('wishlistId cannot be null.');
    }
    if (!productIds) {
      throw new Error('Provide at least 1 product ID to delete.');
    }
    if (this.customerId === null) {
      throw new Error('customerId cannot be null.');
    }
    const wishlistProductIds = [...productIds];
    const formData = new FormData();
    formData.append('formAction', 'DELETE_WISHLIST_ITEMS');
    formData.append('customerId', this.customerId);
    formData.append('wishlistId', wishlistId);
    formData.append('productIds', JSON.stringify(wishlistProductIds));
    const response = await fetch(`/apps/api/wishlists`, {
      method: 'DELETE',
      body: formData,
    });
    const data = await response.json();

    return data;
  }
}

customElements.define('wish-lists', WishLists);
